import { await1xlt6i5aa076q as await_0 } from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { IdentificationAndPassword3vb92u2w4tqhi as IdentificationAndPassword } from '../../../../../lightning-server-sessions-shared/com/lightningkite/lightningserver/sessions/proofs/proofModels.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Companion_getInstance23x6zslwzj0st as Companion_getInstance,
  Companion_getInstance1toimxkidoujm as Companion_getInstance_0,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  get_securityk5vaffknj7i5 as get_security,
  get_oneTimeCodeLetters3t0azo4jzaibk as get_oneTimeCodeLetters,
} from './utils.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import { LabeledViewseav57tyecmf as LabeledView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import {
  FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance,
  ImportantSemantic_getInstancehm7lt56tp87l as ImportantSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { errorText83fzxqvlxz6i as errorText } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { text189ciz0cnr32o as text } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  get_primaryIdentifierRequired2nrw4m53j4kyj as get_primaryIdentifierRequired,
  supportedplmnts7qxgra as supported,
  get_earlyProof3ov5nyo7j4x3i as get_earlyProof,
  render29rcl1dh9m4ii as render,
  render2cu0olic2aw04 as render_0,
  ProofComponent2u514n64q2oz3 as ProofComponent,
} from './ProofComponent.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function BackupCodeProofComponent$render$slambda($onResult, this$0, $option, $primaryIdentifier, $code) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var tmp0_elvis_lhs = $option.method_1.property_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp1_safe_receiver = $primaryIdentifier;
      tmp = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.property_1;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var tmp2_elvis_lhs = tmp;
    var tmp_0 = tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
    var tmp3_elvis_lhs = $option.value_1;
    var tmp_1;
    if (tmp3_elvis_lhs == null) {
      var tmp4_safe_receiver = $primaryIdentifier;
      tmp_1 = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.value_1;
    } else {
      tmp_1 = tmp3_elvis_lhs;
    }
    var tmp5_elvis_lhs = tmp_1;
    $onResult(yield* this$0.p_1.proveBackupCode_juqyr2_k$(new (IdentificationAndPassword())(this$0.type_1, tmp_0, tmp5_elvis_lhs == null ? '' : tmp5_elvis_lhs, yield* await_0($code, $completion)), $completion));
    return Unit_instance;
  }), 1);
}
function TextInput$_get_hint_$ref_uvwrja(p0) {
  return constructCallableReference(() => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
    // Inline function 'com.lightningkite.kiteui.views.placeholder' call
    var tmp = p0.native_1.attributes_1.native_1.placeholder;
    var tmp0_elvis_lhs = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  }, 0, 0, 154, VOID, [p0]);
}
function TextInput$_set_hint_$ref_i30g2i(p0) {
  return constructCallableReference((p0_0) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
    // Inline function 'com.lightningkite.kiteui.views.placeholder' call
    p0.native_1.attributes_1.native_1.placeholder = p0_0;
    return Unit_instance;
  }, 1, 0, 155, VOID, [p0]);
}
function BackupCodeProofComponent$render$lambda($this$invoke) {
  return 'xxxxx-xxxxx-xxxxx-xxxxx';
}
var BackupCodeProofComponentClass;
function BackupCodeProofComponent() {
  if (BackupCodeProofComponentClass === VOID) {
    class $ {
      constructor(p, type) {
        this.p_1 = p;
        this.type_1 = type;
        this.icon_1 = get_security(Companion_getInstance());
        this.via_1 = this.p_1.get_via_18itzv_k$();
        this.property_1 = this.p_1.get_property_msvula_k$();
      }
      get_icon_wont8i_k$() {
        return this.icon_1;
      }
      get_via_18itzv_k$() {
        return this.via_1;
      }
      get_property_msvula_k$() {
        return this.property_1;
      }
      name_vv06me_k$(isPrimary) {
        return 'Enter Backup Code';
      }
      render_1v1gc7_k$(to, primaryIdentifier, option, onResult) {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(to.get_context_h02k06_k$());
        ensureOutermostElement(element);
        to.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        var code = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$('');
        var tmp = Companion_getInstance().done_1;
        var proveBackupCode = Action('Submit', tmp, VOID, VOID, VOID, VOID, BackupCodeProofComponent$render$slambda(onResult, this, option, primaryIdentifier, code));
        // Inline function 'com.lightningkite.kiteui.auth.fieldNoErrorText' call
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        var label = 'Backup Code';
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        element.willAddChild_hz2iwc_k$(element_0);
        element_0.set_content_lzqutq_k$(label);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
        var this_0 = themed(element_0, FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (TextInput())(this_0.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        this_0.willAddChild_hz2iwc_k$(element_1);
        element_1.set_debugName_wihv62_k$('codeInput');
        var tmp_0 = KMutableProperty0();
        var tmp_1 = TextInput$_get_hint_$ref_uvwrja(element_1);
        var tmp_2 = getPropertyCallableRef('hint', 0, tmp_0, tmp_1, TextInput$_set_hint_$ref_i30g2i(element_1));
        element_1.invoke_bnq13k_k$(tmp_2, BackupCodeProofComponent$render$lambda);
        element_1.requestFocus_9180nb_k$();
        element_1.bind_gesskf_k$(element_1.content_1, code);
        element_1.set_action_2ds022_k$(proveBackupCode);
        element_1.set_keyboardHints_w6k1he_k$(get_oneTimeCodeLetters(Companion_getInstance_0()));
        element_1.onStartup_vrxh3i_k$();
        this_0.addChild_2qpft2_k$(element_1);
        element_0.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_0);
        errorText(element);
        // Inline function 'com.lightningkite.kiteui.views.important' call
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        var this_1 = themed(element, ImportantSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (Button())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        this_1.willAddChild_hz2iwc_k$(element_2);
        element_2.set_debugName_wihv62_k$('submitButton');
        text(get_centered(element_2), 'Submit');
        element_2.set_action_2ds022_k$(proveBackupCode);
        element_2.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element_2);
        element.onStartup_vrxh3i_k$();
        to.addChild_2qpft2_k$(element);
      }
      toString() {
        return 'BackupCodeProofComponent(p=' + toString(this.p_1) + ', type=' + this.type_1 + ')';
      }
      hashCode() {
        var result = hashCode(this.p_1);
        result = imul(result, 31) + getStringHashCode(this.type_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof BackupCodeProofComponent()))
          return false;
        if (!equals(this.p_1, other.p_1))
          return false;
        if (!(this.type_1 === other.type_1))
          return false;
        return true;
      }
    }
    protoOf($).get_primaryIdentifierRequired_12mtun_k$ = get_primaryIdentifierRequired;
    protoOf($).supported_g7dhny_k$ = supported;
    protoOf($).get_earlyProof_n45gpi_k$ = get_earlyProof;
    protoOf($).render_7yvau5_k$ = render;
    protoOf($).render_7hnxhp_k$ = render_0;
    initMetadataForClass($, 'BackupCodeProofComponent', VOID, VOID, [ProofComponent()], [0]);
    BackupCodeProofComponentClass = $;
  }
  return BackupCodeProofComponentClass;
}
//region block: exports
export {
  BackupCodeProofComponent as BackupCodeProofComponentdg3wgu2jhew9,
  TextInput$_get_hint_$ref_uvwrja as TextInput$_get_hint_$ref_uvwrjazah8cjxjovpb,
  TextInput$_set_hint_$ref_i30g2i as TextInput$_set_hint_$ref_i30g2i1fq8tygef2z89,
};
//endregion

//# sourceMappingURL=BackupCodeProofComponent.mjs.map
